// import { createSelector } from 'reselect';

export const getRemotelockDevices = (state:any) => state.remotelockDevice.remotelockDevices;
export const getAudits = (state:any) => state.remotelockDevice.audits;
export const getAuditParams = (state:any) => state.remotelockDevice.auditParams;
export const getAuditTotal = (state:any) => state.remotelockDevice.auditTotal;
export const getIsLoading = (state:any) => state.remotelockDevice.isLoading;
export const getStatus = (state:any) => state.remotelockDevice.status;
